import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import SanityPortableText from '../SanityPortableText';
import PancakeIntro from '../PancakeIntro';
import Pancake from './Pancake';
import Container from '../Container';
import Button from '../Button';
import Card from '../Card';

import './G2Reviews.scss';

const G2Reviews = (props) => {
  const { title, text, reviews, theme, className } = props;

  return (
    <Pancake
      className={classnames('PancakeG2Reviews', className)}
      theme={theme}
    >
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        <Button
          className="corporate-light G2Button with-shadow"
          arrow
          to="https://www.g2.com/products/okteto/reviews"
        >
          Read our reviews on G2
        </Button>
        {reviews?.length > 0 && (
          <ul className="G2Reviews">
            {reviews.map((review) => (
              <li>
                <Card key={review.title}>
                  {review.title && (
                    <h3 className="G2ReviewTitle">{review.title}</h3>
                  )}
                  <StarRating rating={review.rating} />
                  {review.author && (
                    <p className="G2ReviewAuthor">{review.author}</p>
                  )}

                  {review._rawText && (
                    <SanityPortableText blocks={review._rawText} />
                  )}
                  <G2Logo />
                </Card>
              </li>
            ))}
          </ul>
        )}
      </Container>
    </Pancake>
  );
};

const G2Logo = () => (
  <svg
    width="67"
    height="67"
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: 40, height: 'auto' }}
  >
    <path
      d="M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z"
      fill="#FF492C"
    />
    <path
      d="M47.9987 25.661H42.2769C42.431 24.7632 42.9871 24.2607 44.1127 23.6912L45.1646 23.1552C47.0473 22.1904 48.0523 21.0983 48.0523 19.3161C48.0523 18.1972 47.6168 17.3128 46.7525 16.6763C45.8882 16.0398 44.8698 15.7249 43.6772 15.7249C42.7546 15.7141 41.8488 15.9725 41.0709 16.4686C40.287 16.951 39.7041 17.5741 39.3423 18.3513L40.9972 20.0129C41.6404 18.7131 42.5717 18.0766 43.7978 18.0766C44.8363 18.0766 45.4728 18.6126 45.4728 19.3563C45.4728 19.9794 45.1646 20.4953 43.972 21.0983L43.2953 21.4266C41.828 22.1703 40.8096 23.0212 40.22 23.986C39.6304 24.9508 39.3423 26.1635 39.3423 27.6308V28.0328H47.9987V25.661Z"
      fill="white"
    />
    <path
      d="M47.2351 30.7664H37.7613L33.0244 38.9672H42.4982L47.2351 47.1747L51.972 38.9672L47.2351 30.7664Z"
      fill="white"
    />
    <path
      d="M33.8416 44.4412C27.8116 44.4412 22.9005 39.5301 22.9005 33.5001C22.9005 27.4701 27.8116 22.559 33.8416 22.559L37.5869 14.7267C36.3536 14.4814 35.0991 14.358 33.8416 14.3582C23.269 14.3582 14.6997 22.9275 14.6997 33.5001C14.6997 44.0727 23.269 52.642 33.8416 52.642C37.8932 52.6495 41.8414 51.3632 45.111 48.9704L40.9704 41.788C38.9895 43.4991 36.4593 44.4408 33.8416 44.4412Z"
      fill="white"
    />
  </svg>
);

const Star = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5.71471L10.4018 4.98642L8 0L5.59766 4.98642L0 5.71471L4.11552 9.4449L3.05357 14.8571L8 12.1996L12.9475 14.8571L11.8839 9.4449L16 5.71471Z"
      fill="#1A263E"
    />
  </svg>
);

const StarHalf = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5.71471L10.4018 4.98642L8 0L5.59766 4.98642L0 5.71471L4.11552 9.4449L3.05357 14.8571L8 12.1996L12.9475 14.8571L11.8839 9.4449L16 5.71471Z"
      fill="#DBE4F7"
    />
    <path
      d="M5.59766 4.98642L8 0V12.1996L3.05357 14.8571L4.11552 9.4449L0 5.71471L5.59766 4.98642Z"
      fill="#1A263E"
    />
  </svg>
);

const StarEmpty = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5.71471L10.4018 4.98642L8 0L5.59766 4.98642L0 5.71471L4.11552 9.4449L3.05357 14.8571L8 12.1996L12.9475 14.8571L11.8839 9.4449L16 5.71471Z"
      fill="#DBE4F7"
    />
  </svg>
);

const StarRating = ({ rating }) => {
  const normalizedRating = Math.round(rating * 2) / 2;

  const fullStars = Math.floor(normalizedRating);
  const hasHalfStar = normalizedRating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <ul className="G2ReviewStars">
      {Array.from({ length: fullStars }).map((_, i) => (
        <li>
          <Star key={`full-${i}`} />
        </li>
      ))}
      {hasHalfStar && (
        <li>
          <StarHalf />
        </li>
      )}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <li>
          <StarEmpty key={`empty-${i}`} />
        </li>
      ))}
    </ul>
  );
};

export const query = graphql`
  fragment SanityG2Reviews on SanityG2Reviews {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    reviews {
      _rawText
      author
      rating
      title
    }
    theme
  }
`;

export default G2Reviews;
